import * as React from "react";

interface Props {
    color: string,
    bkhcolor?: string,
    dcolor?: string,
    icon: string,
    end?: boolean,
    onClick?: any,
    htext?: string,
    text?: string,
    btext?: string,
    description?: string,
    bkhimage?: string,
    max?: string
}

interface State {
    hover: boolean
}

export default class CardBox extends React.Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            hover: false
        };
    }

    setHover(status) {
        this.setState({
            hover: status
        });
    }

    render() {
        let img_next = "/static/img/next.png";
        if(this.state.hover)
            img_next = "/static/img/end.png";

        let styles = {

        };

        if(this.props.bkhcolor) {
            styles = {
                background: this.state.hover ? `${this.props.bkhcolor}` : "",
                color: this.props.color,
                maxWidth: this.props.max
            };
        }

        if(this.props.bkhimage) {
            styles = {
                backgroundSize: "cover",
                backgroundImage: this.state.hover ? `url(${this.props.bkhimage})` : "",
                color: this.props.color,
                maxWidth: this.props.max
            };
        }

        let h_style = {
            color: this.props.color
        };

        let b_style = {
            color: this.props.color,
            height: "80px",
            marginBottom: "9px"
        };

        if(this.props.btext) {
            b_style = {
                color: this.props.color,
                height: "35px",
                marginBottom: "-25px"
            }
        }

        let d_style = {
            color: (this.props.dcolor ? this.props.dcolor : this.props.color),
            display: "block"
        };

        if(this.props.description === undefined  || this.props.description === null || this.props.description == "")
            d_style.display = "none";

        return (
            <div className="cardBox" style={styles} onClick={this.props.onClick} onMouseOver={() => this.setHover(true)} onMouseOut={() => this.setHover(false)}>
                <div className="base-image">
                    <div className="header-image margin" style={ { paddingTop: '20px' } } >
                        <span className={ this.props.icon } style={ { fontSize: '30px', color: '#3C92EA' } } > </span>
                    </div>
                </div>
                {
                    this.props.htext && (
                        <h5 style={h_style}>{this.props.htext}</h5>
                    )
                }
                {
                    this.props.text && (
                        <h4 style={b_style} dangerouslySetInnerHTML={{__html: this.props.text}} />
                    )
                }
                {
                    this.props.btext && (
                        <h3 style={h_style}>{this.props.btext}</h3>
                    )
                }
                <div className="description margin" style={d_style}>
                    {this.props.description}
                </div>
                <hr style={{ marginBottom: "38px" }} />
                <div className="next">
                    <img src={img_next} />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/CardBox.tsx